import { Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'

import { Tooltip } from 'src/chrome'

import { cardBoxShadow, feature } from './pricingTableStyles'

type FeatureProps = {
  id: number | string
  title: string
  description: string
  value?: string
  hasFeature?: boolean
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right'
  hasBoxShadow?: boolean
  style?: React.CSSProperties
}

const Feature: React.FC<FeatureProps> = props => {
  const {
    id,
    title,
    description,
    value,
    tooltipPosition,
    style,
    hasFeature = true,
    hasBoxShadow = false,
  } = props
  return (
    <div
      style={{
        ...feature,
        ...(style ?? {}),
        ...(hasBoxShadow ? { boxShadow: cardBoxShadow } : {}),
      }}
      id={`feature_${id}`}
    >
      <Text
        type="body"
        alignment="left"
        color={hasFeature ? 'primaryHeading' : 'primaryBody'}
        isStrikeThrough={!hasFeature}
      >
        {title}
      </Text>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {value && (
          <span
            style={{
              color: 'rgba(0,0,0,.65)',
              marginRight: description ? 15 : 25,
            }}
          >
            {value}
          </span>
        )}
        {description && (
          <Tooltip
            hoverIcon={'HELPCIRCLE'}
            message={description}
            position={tooltipPosition}
          />
        )}
      </div>
    </div>
  )
}

export default Feature
